export enum Roles {
  "analista" = "analista",
  "admin" = "admin",
  "agente" = "agente",
  "analyst" = "analyst",
  "client" = "client",
}
